const styles = (theme) => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '60%',
      marginLeft: '2rem',
      marginTop: '2rem',
    },
  };
};

export default styles;
